/**
 * Notificaciones in-app del solicitante (campana del header) · feed del CORE
 * (solicitudes de pago): autorizaciones por nivel, autorización completa,
 * rechazos, bajas y contabilización. Se fusiona en la campana con las
 * resoluciones de solicitudes de catálogo (módulo Administracion).
 */
import { axiosClient } from "@/shared/api/axios-client";

export type TipoNotificacion =
  | "AutorizacionNivel"
  | "AutorizacionCompleta"
  | "Rechazo"
  | "Baja"
  | "Contabilizacion";

export interface Notificacion {
  id: string;
  tipo: TipoNotificacion;
  solicitudId: string;
  numeroSolicitud: number;
  mensaje: string;
  creadaAt: string;
  /** null = aún no vista (alimenta el badge). */
  vistaAt: string | null;
}

export async function listarMisNotificaciones(): Promise<Notificacion[]> {
  const { data } = await axiosClient.get<Notificacion[]>("/api/notificaciones");
  return data;
}

export async function contarMisNotificacionesNoVistas(): Promise<number> {
  const { data } = await axiosClient.get<{ total: number }>(
    "/api/notificaciones/no-vistas/count"
  );
  return data.total;
}

export async function marcarMisNotificacionesVistas(): Promise<void> {
  await axiosClient.post("/api/notificaciones/marcar-vistas");
}

/** Oculta la notificación de MI campana (soft-delete · el registro persiste). */
export async function ocultarMiNotificacion(id: string): Promise<void> {
  await axiosClient.delete(`/api/notificaciones/${id}`);
}
